import React, {useState} from "react";
import logo from "../../assets/media/logos/default.svg";
import googleLogo from "../../assets/media/svg/brand-logos/google-icon.svg";
import fbLogo from "../../assets/media/svg/brand-logos/facebook-4.svg";
import appleLogo from "../../assets/media/svg/brand-logos/apple-black.svg";
import {useForm} from "react-hook-form";
import axios from "axios";
import PasswordInput from "../../Components/Inputs/PasswordInput";
import {useNavigate, useParams} from "react-router-dom";
import TextInput from "../../Components/Inputs/TextInput";
import swal from "sweetalert";
import {errorAlert} from "../../Components/Alerts/BasicAlert";

export default function () {
  const {register, handleSubmit} = useForm();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState(false);
  const {token, email} = useParams();

  const resetPassword = (data) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
    data.token = token;
    data.email = email;
    axios.post(`/email/reset-password`, data).then(res => {
      if(res.data.status === "success"){
        swal('თქვენი პაროლი განახლდა წარმატებით', {
          icon: "success",
        });
        setRedirect(true);
      }
    }).catch(err => {
      console.log(err.response);
        if (err.response) {
          setErrors({password: err.response.data.errors?.password?.[0]} || {});
        }
      if (err.response.data.status) {
          errorAlert(err.response.data.status);
      }
    })
  }

  if(redirect) navigate('/login');

  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid w-100">
        <div className="d-flex flex-column flex-lg-row-auto bg-primary w-xl-600px positon-xl-relative">
          <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
            <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
              <img alt="Logo" src={logo} className="h-40px"/>
              <h1 className="fw-bolder text-white fs-2qx pb-5 pb-md-10">Popmart Dashboard</h1>
            </div>
            <div
              className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
              style={{backgroundImage: 'url(assets/media/illustrations/sketchy-1/2.png)'}}/>
          </div>
        </div>
        <div className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-500px p-10 p-lg-15 mx-auto">
              <form className="form w-100" noValidate="novalidate" onSubmit={handleSubmit(resetPassword)}>
                <div className="text-center mb-10">
                  <h1 className="text-dark mb-3">Reset Password</h1>
                </div>

                <TextInput
                  label="Password"
                  name="password"
                  type="password"
                  register={register}
                  errorMessage={errors.password}
                />

                <PasswordInput
                  label="Repeat password"
                  name="password_confirmation"
                  type="password"
                  register={register}
                  errorMessage={errors.password_confirmation}
                />

                <div className="text-center">
                  <button type="submit" id="kt_sign_in_submit" className="btn btn-lg btn-primary w-100 mb-5">
                    <span className="indicator-label">Update</span>
                  </button>

                  <div className="text-center text-muted text-uppercase fw-bolder mb-5 invisible">or</div>
                  <a href="#" className="btn btn-flex flex-center btn-light btn-lg w-100 mb-5 invisible">
                    <img alt="Logo" src={googleLogo} className="h-20px me-3"/>Continue with Google</a>
                  <a href="#" className="btn btn-flex flex-center btn-light btn-lg w-100 mb-5 invisible">
                    <img alt="Logo" src={fbLogo} className="h-20px me-3"/>Continue with Facebook</a>
                  <a href="#" className="btn btn-flex flex-center btn-light btn-lg w-100 invisible">
                    <img alt="Logo" src={appleLogo} className="h-20px me-3"/>Continue with Apple</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}